import * as types from './mutation-types'

export default {
    [types.SET_CONTACTS](state, contacts) {
        state.contacts = contacts
    },
    [types.ADD_CONTACT](state, data) {
        state.contacts = [data.contact, ...state.contacts]
    },
   
    [types.UPDATE_CONTACT] (state, data) {
        let pos = state.contacts.findIndex(contact => contact.id === data.contact.id)
        state.contacts.splice(pos, 1)
        state.contacts = [data.contact, ...state.contacts]
    },

}
